<template>
  <page :title="i18n.wallet">
    <div @click="selectedItem($event)">
      <!-- NG 单币种适配：余额卡常显（₦0 也显示），仅聚焦子钱包时隐藏 -->
      <div
        :class="
          selected
            ? selected.pId === -10
              ? 'wallet-balance selected'
              : 'wallet-balance'
            : 'wallet-balance'
        "
        v-if="selected ? selected.pId === -10 : true"
      >
        <div class="wallet-balance-warp">
          <div class="wallet-balance-label">{{ i18n.balance }}</div>
          <div class="wallet-balance-value">
            {{ user && user.pcurrencyName }}{{ (user && user.pbalance) || 0 }}
          </div>
          <div class="wallet-balance-label">
            {{ i18n.deposit }}: {{ user.pyajin }}
          </div>
        </div>
        <div class="wallet-balance-more">
          <img src="../../assets/imgs/wallet_more.png" />
        </div>
        <div class="Mask" :data-item="JSON.stringify({ pId: -10 })"></div>
      </div>
      <template v-for="item in list">
        <div
          :class="
            selected
              ? item.pDailiId === selected.pDailiId &&
                item.pCurrencyType === selected.pCurrencyType
                ? 'wallet-balance selected'
                : 'wallet-balance'
              : 'wallet-balance'
          "
          v-if="
            selected
              ? item.pDailiId === selected.pDailiId &&
                item.pCurrencyType === selected.pCurrencyType
              : true
          "
          :key="item.pId"
        >
          <div class="wallet-balance-warp">
            <div class="wallet-balance-label">{{ i18n.balance }}</div>
            <div class="wallet-balance-value">
              {{ item.pCurrencySymbol }}{{ item.pBalance || 0.0 }}
            </div>
            <div class="wallet-balance-label">
              {{ i18n.deposit }}: {{ item.pDepositAmount || 0 }}
            </div>
          </div>
          <div class="wallet-balance-more">
            <img src="../../assets/imgs/wallet_more.png" />
          </div>
          <div class="Mask" :data-item="JSON.stringify(item)"></div>
        </div>
      </template>
    </div>
    <!-- 提现按钮 -->
    <div class="wallet-btn">
      <div @click="goRouter(`/wallet_out`)">
        <img src="../../assets/imgs/wallet_push.png" />
        <span>{{ i18n.wallet_out }}</span>
      </div>
    </div>

    <!-- 卡包区块：还原自 H5 已实现版本（PowerGo_ec a3508211），App 端钱包未实现不作为参考 -->
    <div class="payment_warp" v-if="payMode">
      <PaymentCardItem
        v-if="payModeList.length"
        :pId="pId"
        :payMode="payMode"
        :payList="payModeList"
        @refresh="getUserPayCard"
      />
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { PAYMODE } from "../../apis/payment"
import { USER_INFO, USER_WALLET, USER_CARD } from "../../apis/user"

import PaymentCardItem from "../payment/component/card_item.vue"
export default {
  computed: {
    ...mapState(["user", "cabinet", "qrcode"]),
    i18n() {
      return this.$t("mine")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    i18nPayment() {
      return this.$t("payment")
    },
    i18nConfirm() {
      return this.$t("confirm")
    }
  },
  components: {
    PaymentCardItem
  },
  data() {
    return {
      list: [],
      selected: null,
      query: null,
      querypath: window.location.href.split("?")[1],
      payModeList: [],
      payMode: "",
      pId: "", // 代理或平台支付配置id
      publicKey: "", // 支付通道的公钥
      paymentConfig: null
    }
  },
  methods: {
    selectedItem(e) {
      console.log(JSON.parse(e.target.dataset.item))
      let selecteddata = JSON.parse(e.target.dataset.item)
      if (
        this.selected &&
        selecteddata.pDailiId === this.selected.pDailiId &&
        selecteddata.pCurrencyType === this.selected.pCurrencyType
      ) {
        this.selected = null
        this.$store.commit("wallet", null)
        return
      }
      this.$store.commit("wallet", selecteddata)
      this.selected = selecteddata
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          this.$loading(false)
          if (resp.user) {
            this.$store.commit("user", resp.user)
            this.getWalletList()
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
      this.getPayMode()
    },
    goRouter(path) {
      this.$router.push(path)
    },
    getWalletList() {
      this.$loading(true)
      this.$get(
        USER_WALLET,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          this.list = resp.data
          if (this.list && this.list.length > 0) {
            this.selected = this.list[0]
            this.$store.commit("wallet", this.selected)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.getWalletList()
          })
          console.log(error)
        }
      )
    },

    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true)
      const qrcode = this.qrcode || this.$route.query.qrcode || ""
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentId: this.agentId
      })
      let cardList = []
      if (data && data.length) {
        cardList = data.map((item) => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          }
        })
        this.cardList = cardList
      }
      this.$loading(false)
      this.payModeList = cardList
    },
    // 获取支付方式列表
    getPayMode() {
      this.$loading(true)
      let agentId = ""
      const qrcode = this.qrcode || this.$route.query.qrcode || ""
      if (this.payType === "CZ") {
        agentId = this.wallet
          ? this.wallet.pDailiId
          : this.cabinet.userWallet.pDailiId
      }
      this.$get(
        this.payType !== "CZ"
          ? `${PAYMODE}?id=${qrcode}`
          : `${PAYMODE}?agentId=${agentId}`,
        {},
        async (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            let list = resp.data
            list.map((v) => {
              if (v.pPaymentType === "STRIPE_CARD") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === "PAYPAL") {
                v.label = "Paypal"
                v.phone = "all"
              } else if (v.pPaymentType === "STRIPE_KLARNA") {
                v.label = "Klarna"
                v.phone = "all"
              } else if (v.pPaymentType === "MIDTRANS_CARD") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === "MIDTRANS_GOPAY") {
                v.label = "GOPAY"
              } else if (v.pPaymentType === "MyFatoorah") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === "PaymentEz") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (
                v.pPaymentType === "PAYSTACK_DVA" ||
                v.pPaymentType === "PayStack_DVA"
              ) {
                // 对齐 confirm.vue：大小写不敏感，避免被 label filter 丢弃
                v.label = "Virtual Account"
                v.phone = "all"
              }
            })
            list = list.filter((v) => !!v.label)

            if (list.length > 0) {
              this.payMode = list[0].pPaymentType
              this.currencySymbol = list[0].currencySymbol // 货币符号
              this.currencyname = (list[0].configDetails || {}).currency // 货币类型
              this.publicKey = list[0].publicKey || ""
              this.paymentConfig = list[0].paymentConfig
              this.pId = list[0].pId
              this.country = (list[0].configDetails || {}).accountCountry
              console.log(this.publicKey, this.payMode)
              if (
                list[0].publicKey &&
                list[0].pPaymentType !== "M-PESA" &&
                list[0].pPaymentType !== "MIDTRANS_CARD" &&
                list[0].pPaymentType !== "MIDTRANS_GOPAY"
              ) {
                this.loadStripeScript(list[0].publicKey)
              }
              this.payInfo = list[0]
            }
            console.log("list======", list)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
      this.getUserPayCard()
    }
  },
  created() {
    this.query = this.$route.query
    this.loadUser()
  }
}
</script>

<style lang="less">
.selected {
  border: solid 2px #309df7;
  border-top: solid 2px #309df7 !important;
}
.Mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.wallet-balance {
  position: relative;
  margin: 40px;
  // background: linear-gradient(90deg,#EBD460 0%,#E5BE53 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 40px 60px 20px;
  color: #333333;
  display: flex;
  align-items: center;
  box-shadow: 0 0 0 2px rgba(217, 217, 217, 0.2);
  &-warp {
    flex: 1;
  }
  &-label {
    font-size: 32px;
  }
  &-value {
    font-size: 70px;
    font-weight: bold;
  }
  &-more {
    & img {
      width: 20px;
      height: 30px;
      display: block;
    }
  }
}
.wallet-btn {
  display: flex;
  padding: 20px 40px;
  & div {
    flex: 1;
    height: 72px;
    line-height: 72px;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #333333;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    margin: 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & img {
    width: 40px;
    height: 40px;
    display: block;
  }
  & span {
    padding-left: 15px;
  }
}
.payment_warp {
  min-height: 62vh;
  overflow-y: scroll;
  margin: 42px 32px 0;

  // 全局覆盖 card_item.vue 的卡片样式（因 card_item.vue 的 scoped 样式可能未生效）
  .card-payment-item {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    border-radius: 16px;
    background: #fff;
    margin-top: 20px;
    border: 1px solid #e8e8e8;

    & img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
  .card-payment-item-info {
    display: flex !important;
    align-items: center;
    flex: 1;
    min-width: 0;
  }
  .card-payment-item-info .content {
    padding-left: 12px;
    min-width: 0;
  }
  .card-payment-item-info .title {
    font-size: 28px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .card-payment-item-operate {
    flex-shrink: 0;
    margin-left: 16px;
  }
  .card-payment-item-operate-text {
    display: inline-block;
    padding: 8px 16px;
    font-size: 24px;
    color: #fc0d1b;
    border: 1px solid #fc0d1b;
    border-radius: 10px;
    background: transparent;
    cursor: pointer;
    white-space: nowrap;
  }
  .payment-card {
    margin: 0;
  }

  .confirm-btns {
    padding: 60px;
  }
  + .popup {
    .creditcard-input {
      margin: 48px 48px 80px;
      padding: 20px;
      border-radius: 20px;
      border: 1px solid #e4e7ed;
    }

    .creditcard-btn {
      margin: 48px;
      color: #fff;
      background: #000;
    }
    .confirm-btns {
      padding: 60px;
    }
  }
}
</style>
